/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_reactions = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of reactions`)
};

const es_pcr_reactions = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de reacciones`)
};

const de_pcr_reactions = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Reaktionen`)
};

const nl_pcr_reactions = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aantal reacties`)
};

const fr_pcr_reactions = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de réactions`)
};

const it_pcr_reactions = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di reazioni`)
};

const pt_br2_pcr_reactions = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de reações`)
};

const pt_pcr_reactions = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de reações`)
};

const ja_pcr_reactions = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反応数`)
};

const zh_pcr_reactions = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反应数量`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_reactions = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_reactions(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_reactions", locale)
	if (locale === "en") return en_pcr_reactions(inputs)
	if (locale === "es") return es_pcr_reactions(inputs)
	if (locale === "de") return de_pcr_reactions(inputs)
	if (locale === "nl") return nl_pcr_reactions(inputs)
	if (locale === "fr") return fr_pcr_reactions(inputs)
	if (locale === "it") return it_pcr_reactions(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_reactions(inputs)
	if (locale === "pt") return pt_pcr_reactions(inputs)
	if (locale === "ja") return ja_pcr_reactions(inputs)
	return zh_pcr_reactions(inputs)
};